import { EventSuccess } from './EventSuccess';

export default EventSuccess;
